// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.achievement-group {
  margin-bottom: 20px;
  color: #d0d0d0;

}

.achievement-title {
  color: #d0d0d0;
  font-size: 1.5em;
  margin-bottom: 10px;
}

.achievement-item {
  margin: 10px 0;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 10%;
  color: #d0d0d0;

}

.achievement-image img {
  max-width: 10px;
  /* Ajusta el ancho máximo según necesites */
  max-height: 10px;
  /* Ajusta la altura máxima según necesites */
  object-fit: contain;
  /* Mantiene las proporciones de la imagen sin recortarla */
}

.achievement-name {
  font-size: 1.2em;
  color: #eeeaea;
}

.achievement-description {
  font-size: 1em;
  color: #e0e0e0;
  margin-bottom: 10px;
}

.achievement-rank {
  font-weight: bold;
  color: #e0e0e0;
}

.container_unlocks {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 70%;
  min-width: 20%;
  margin: auto;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.5);
  margin-top: auto;
}

.btn-lock {
  position: relative;
  top: calc(50% - 32px);
  left: calc(50% - 32px);
  display: inline-block;
  background: #5bffa8;
  width: 64px;
  height: 64px;
  box-sizing: border-box;
  padding: 12px 0 0 18px;
  border-radius: 50%;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.btn-unlock {
  position: relative;
  top: calc(50% - 32px);
  left: calc(50% - 32px);
  display: inline-block;
  background: #ff5b5b;
  width: 64px;
  height: 64px;
  box-sizing: border-box;
  padding: 12px 0 0 18px;
  border-radius: 50%;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.btn-lock svg {
  fill: none;
  transform: translate3d(0, 0, 0);
}


.btn-lock svg .lock {
  stroke: #060606;
  stroke-width: 4;
  stroke-linejoin: round;
  stroke-linecap: round;
  stroke-dasharray: 36;
  transition: all 0.4s ease;
}

.btn-lock svg .lockb {
  fill: #060606;
  fill-rule: evenodd;
  clip-rule: evenodd;
  transform: rotate(8deg);
  transform-origin: 14px 20px;
  transition: all 0.2s ease;
}
`, "",{"version":3,"sources":["webpack://./src/components/profile/unlockables/unlockables.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;;AAEhB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;;AAEhB;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,gBAAgB;EAChB,4CAA4C;EAC5C,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,+BAA+B;AACjC;;;AAGA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;AAC3B","sourcesContent":[".achievement-group {\n  margin-bottom: 20px;\n  color: #d0d0d0;\n\n}\n\n.achievement-title {\n  color: #d0d0d0;\n  font-size: 1.5em;\n  margin-bottom: 10px;\n}\n\n.achievement-item {\n  margin: 10px 0;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 10%;\n  color: #d0d0d0;\n\n}\n\n.achievement-image img {\n  max-width: 10px;\n  /* Ajusta el ancho máximo según necesites */\n  max-height: 10px;\n  /* Ajusta la altura máxima según necesites */\n  object-fit: contain;\n  /* Mantiene las proporciones de la imagen sin recortarla */\n}\n\n.achievement-name {\n  font-size: 1.2em;\n  color: #eeeaea;\n}\n\n.achievement-description {\n  font-size: 1em;\n  color: #e0e0e0;\n  margin-bottom: 10px;\n}\n\n.achievement-rank {\n  font-weight: bold;\n  color: #e0e0e0;\n}\n\n.container_unlocks {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 70%;\n  min-width: 20%;\n  margin: auto;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.5);\n  margin-top: auto;\n}\n\n.btn-lock {\n  position: relative;\n  top: calc(50% - 32px);\n  left: calc(50% - 32px);\n  display: inline-block;\n  background: #5bffa8;\n  width: 64px;\n  height: 64px;\n  box-sizing: border-box;\n  padding: 12px 0 0 18px;\n  border-radius: 50%;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.btn-unlock {\n  position: relative;\n  top: calc(50% - 32px);\n  left: calc(50% - 32px);\n  display: inline-block;\n  background: #ff5b5b;\n  width: 64px;\n  height: 64px;\n  box-sizing: border-box;\n  padding: 12px 0 0 18px;\n  border-radius: 50%;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.btn-lock svg {\n  fill: none;\n  transform: translate3d(0, 0, 0);\n}\n\n\n.btn-lock svg .lock {\n  stroke: #060606;\n  stroke-width: 4;\n  stroke-linejoin: round;\n  stroke-linecap: round;\n  stroke-dasharray: 36;\n  transition: all 0.4s ease;\n}\n\n.btn-lock svg .lockb {\n  fill: #060606;\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  transform: rotate(8deg);\n  transform-origin: 14px 20px;\n  transition: all 0.2s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
